/**
 * Created by inonstelman on 1/5/15.
 */
(function () {
    "use strict";

    //@ngInject
    function FacebookPixelTrackingServiceCtor(FacebookPixel, Gon, $q, $log, DeviceService, $timeout, $cookies) {

        this.$q = $q;
        this.$log = $log;
        this.$timeout = $timeout;
        this.facebookLoginResponse = null;
        this.Gon = Gon;
        this.pendingEvents = [];
        this.touchDevice = DeviceService.checkIfTouchDevice();
        this.$cookies = $cookies;
        this.pixelEnabled = this.Gon.facebook_pixel_id && this.Gon.facebook_pixel_id.length > 0 ;

        FacebookPixel.then(
            function success(fbq) {

                this.fbq = fbq;
                // For now we can get the 'hb_mta_uuid' cookie value directly from the cookies, but we might to change the field to HttpOnly
                // in the future
                var external_id = this.$cookies.get('hb_mta_uuid');
                var eventArgs = external_id ? {external_id: external_id} : {};
                this._sendEvent('init', this.Gon.facebook_pixel_id, eventArgs);
                if (this.pendingEvents.length > 0){

                    this.pendingEvents.forEach(function(eventData, index, object) {
                        this._sendEvent(eventData.eventType, eventData.param, eventData.eventArgs);
                    }.bind(this));

                    this.pendingEvents = [];

                }
            }.bind(this)
        );
    }

    Services.FacebookPixelTrackingService = Class(function () {
        return {
            constructor: FacebookPixelTrackingServiceCtor,

            track: function track(eventName, eventArgs){
                this._sendEvent('track',eventName, eventArgs);
            },

            trackCustom: function track(eventName, eventArgs){
                this._sendEvent('trackCustom', eventName, eventArgs);
            },

            trackOnDesktopIfStartedMobile: function trackOnDesktopIfStartedMobile(currUser, eventName, eventArgs){
                if (!this.touchDevice && currUser.onboarding_container && currUser.onboarding_container.onboarding_start_device == 'mobile') {
                    this.track(eventName, eventArgs);
                }
            },
            trackCustomOnDesktopIfStartedMobile: function trackCustomOnDesktopIfStartedMobile(currUser, eventName, eventArgs){
                if (!this.touchDevice && currUser.onboarding_container && currUser.onboarding_container.onboarding_start_device == 'mobile') {
                    this._sendEvent('trackCustom', eventName, eventArgs);
                }
            },

            _sendEvent: function _sendEvent(eventType, param, eventArgs){
                this.$log.debug('[FacebookPixelEvent: ' + this.pixelEnabled + '] ' + eventType + ', ' + param + ': ' + eventArgs);
                if (this.pixelEnabled){
                    if (this.fbq){
                        // timeout is used to when events are triggered from controllers ctors and the ui router dosen't updated
                        // the window url that is used for the reporting
                        this.$timeout(function(){
                            this.fbq(eventType, param, eventArgs);
                        }.bind(this),0);


                    }else{

                        this.pendingEvents.push({eventType: eventType, param: param, eventArgs: eventArgs});
                    }
                }


            }
        };
    });
}());
